export class PliValueType {
  pliValueTypeId: number;
  name: string;
  definition: string;
}
